import React from "react";

const IconTalk = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5001 4.64648C17.5001 6.0272 14.1422 7.14648 10.0001 7.14648C5.85792 7.14648 2.50006 6.0272 2.50006 4.64648M17.5001 4.64648C17.5001 3.26577 14.1422 2.14648 10.0001 2.14648C5.85792 2.14648 2.50006 3.26577 2.50006 4.64648M17.5001 4.64648V7.14648M2.50006 4.64648L2.50006 16.3132C2.49541 16.7139 2.77989 17.1092 3.3295 17.4656C3.87911 17.8221 4.67775 18.1292 5.65809 18.3613C6.63843 18.5933 7.77174 18.7433 8.96248 18.7988C10.1532 18.8542 11.3665 18.8134 12.5001 18.6798M17.5001 10.4798L15.0001 14.6465H18.3334L15.8334 18.8132M2.50006 10.4798C2.50126 10.8694 2.77563 11.2535 3.30127 11.6015C3.82691 11.9495 4.58927 12.2517 5.52753 12.4841C6.46578 12.7164 7.55396 12.8724 8.70523 12.9397C9.85651 13.007 11.039 12.9836 12.1584 12.8715" stroke="#29394D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  );
};

export default IconTalk;
